// ──────────────────────────────────────────────────────────────
// REMISES OFFICIELLES SHOW ÉVÉNEMENT
// Entreprise -15% | Association -15% | CE -10% | Partenaire -20%
// ──────────────────────────────────────────────────────────────

export const PROFILE_DISCOUNTS = {
  particulier: { label: 'Particulier', pct: 0,  color: 'var(--ink)',    bg: 'var(--bg)' },
  entreprise:  { label: 'Entreprise',  pct: 15, color: '#1F9D7A',      bg: 'rgba(31,157,122,0.08)' },
  association: { label: 'Association', pct: 15, color: '#5DBCBF',      bg: 'var(--teal-mist)' },
  ce:          { label: 'CE',          pct: 10, color: '#C58B19',      bg: 'rgba(197,139,25,0.08)' },
  groupe:      { label: 'Partenaire',  pct: 20, color: '#D4AF37',      bg: 'rgba(212,175,55,0.08)' },
};

export function getDiscountInfo(profile, publicPrice, clientPrice) {
  const cfg  = PROFILE_DISCOUNTS[profile] || PROFILE_DISCOUNTS.particulier;
  const save = Math.round((publicPrice - clientPrice) * 100) / 100;
  return {
    ...cfg,
    saving:     save > 0 ? save : 0,
    hasDiscount: save > 0,
  };
}
